<template>
    <v-row class="row--small" style="position: relative">
        <v-col :class="`datetime-picker-${className}`">
            <v-menu max-width="360" v-model="showsDate" :close-on-content-click="false" :attach="`.datetime-picker-${className}`" top right>
                <template #activator="{ attrs, on }">
                    <v-text-field :label="`${label}(날짜)`" type="date" max="2999-12-31" :value="date" v-bind="{ ...attrs, ...attrs_input }" v-on="on" readonly />
                </template>
                <v-date-picker v-model="date" @change="showsDate = false" />
            </v-menu>
        </v-col>
        <v-col v-if="!hideTime">
            <v-menu max-width="360" v-model="showsTime" :close-on-content-click="false" :attach="`.datetime-picker-${className}`" top left>
                <template #activator="{ attrs, on }">
                    <v-text-field :label="`${label}(시간)`" type="time" :value="time" v-bind="{ ...attrs, ...attrs_input }" v-on="on" readonly />
                </template>
                <v-time-picker v-model="time" use-seconds @click:seconds="showsTime = false" />
            </v-menu>
        </v-col>
    </v-row>
</template>

<script>
import dayjs from "dayjs";

export default {
    props: {
        value: { type: [Date, Number, String], default: null },
        label: String,
        hideTime: { type: Boolean, default: false },
        attrs_input: { type: Object, default: () => ({}) },
    },
    data: () => ({
        showsDate: false,
        showsTime: false,
        date: null,
        time: null,

        className: Math.random().toString().slice(2),
    }),
    mounted() {
        this.init();
    },
    watch: {
        date() {
            this.time ? this.$emit("input", `${this.date} ${this.time}`) : this.$emit("input", this.date);
        },
        time() {
            this.$emit("input", this.date && this.time ? `${this.date} ${this.time}` : null);
        },
        value() {
            this.init();
        },
    },
    methods: {
        init() {
            if (this.value) {
                this.date = dayjs(this.value).format("YYYY-MM-DD");
                this.time = dayjs(this.value).format("HH:mm:ss");
            } else {
                this.date = null;
                this.time = null;
            }
        },
        // emit() {
        //     this.hideTime ? this.$emit("input", this.date) : this.$emit("input", this.date || this.time ? `${this.date} ${this.time}` : null);
        // },
    },
};
</script>

<style lang="scss" scoped>
</style>
